"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./style.css");
var _reactFilerobotImageEditor = _interopRequireWildcard(require("react-filerobot-image-editor"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//@ts-ignore

const SnekStudio = ({
  src,
  name,
  isOpen,
  onComplete,
  shouldClose
}) => {
  if (!isOpen) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFilerobotImageEditor.default, {
    defaultSavedImageName: name,
    showBackButton: true,
    closeAfterSave: true,
    savingPixelRatio: 0,
    previewPixelRatio: 0,
    source: src,
    onSave: (editedImageObject, designState) => {
      const {
        imageBase64,
        imageCanvas
      } = editedImageObject;
      if (imageCanvas && imageBase64) {
        imageCanvas.toBlob(blob => {
          onComplete(blob, editedImageObject);
        });
      }
    },
    onClose: shouldClose,
    annotationsCommon: {
      fill: '#ff0000'
    },
    Text: {
      text: 'Text...'
    },
    tabsIds: [_reactFilerobotImageEditor.TABS.RESIZE, _reactFilerobotImageEditor.TABS.ADJUST, _reactFilerobotImageEditor.TABS.FILTERS, _reactFilerobotImageEditor.TABS.FINETUNE, _reactFilerobotImageEditor.TABS.ANNOTATE, _reactFilerobotImageEditor.TABS.WATERMARK]
  });
};
var _default = SnekStudio;
exports.default = _default;